import React from "react";

// ════════════════════════════════════════════════════════════════
//  Emigratie-checklist NL → Portugal (EU-burger).
//  Algemene, gedateerde leidraad — GEEN juridisch/fiscaal advies.
//  Stand: juni 2026. Verifieer altijd bij AIMA, Finanças, Segurança
//  Social en een eigen fiscalist/advogado; regels wijzigen.
// ════════════════════════════════════════════════════════════════
const STEPS = [
  { n:1, t:"NIF — fiscaal nummer", d:"Número de Identificação Fiscal bij Finanças (of via een fiscaal vertegenwoordiger/advocaat vóór aankomst). Nodig voor vrijwel alles: huren, kopen, bankrekening, contracten." },
  { n:2, t:"Bankrekening (PT IBAN)", d:"Open een Portugese rekening; veel verhuurders/diensten vragen een PT-IBAN voor automatische incasso." },
  { n:3, t:"Verblijfsregistratie (CRUE)", d:"Als EU-burger geen visum nodig. Na 3 maanden verblijf registreer je je bij de câmara municipal → Certificado de Registo de Cidadão da União Europeia (CRUE). Na 5 jaar: permanent verblijf." },
  { n:4, t:"Segurança Social (NISS)", d:"Vraag een NISS-nummer aan voor werk, zelfstandigheid (recibos verdes) en sociale rechten." },
  { n:5, t:"SNS-zorg (Número de Utente)", d:"Schrijf je in bij het lokale centro de saúde voor een Número de Utente → toegang tot de publieke gezondheidszorg (SNS)." },
  { n:6, t:"Belasting — let op: NHR is vervangen", d:"Het oude NHR-regime sloot eind 2023. Sinds 2024 geldt IFICI (informeel 'NHR 2.0') voor specifieke beroepen/sectoren. Of je kwalificeert hangt sterk af van je situatie — laat dit door een Portugese fiscalist toetsen vóór verhuizing." },
  { n:7, t:"School inschrijven", d:"Openbaar onderwijs: matrículas meestal april–juni via het Portal das Matrículas (inloggen met NIF). Internationale/privéscholen hebben een eigen inschrijfkalender en wachtlijsten — ruim op tijd contact opnemen." },
  { n:8, t:"Auto & rijbewijs", d:"NL-rijbewijs is geldig; registreer je bestuurder bij IMT. Een NL-auto importeren kan binnen een termijn na vestiging (ISV-belasting; vrijstelling mogelijk bij verhuizing — voorwaarden via Alfândega)." },
  { n:9, t:"Wonen: huren vs kopen", d:"Veel gezinnen huren eerst 6–12 maanden om de regio te leren kennen. Bij verhuur van eigen vastgoed: registreer de activiteit bij de AT. Laat koopcontracten (CPCV) door een advogado checken." },
];
export function EmigratieChecklist() {
  const [open, setOpen] = React.useState(false);
  return (
    <section className="emig-section">
      <h4 onClick={()=>setOpen(o=>!o)} style={{cursor:"pointer"}}>
        🧭 Emigratie-checklist NL → Portugal <span className="emig-toggle">{open ? "▲" : "▼"}</span>
      </h4>
      {open && (
        <>
          <ol className="emig-list">
            {STEPS.map(s => (
              <li key={s.n} className="emig-item">
                <div className="emig-t">{s.t}</div>
                <div className="emig-d">{s.d}</div>
              </li>
            ))}
          </ol>
          <p className="emig-foot">Algemene leidraad, stand juni 2026 — <strong>geen juridisch of fiscaal advies</strong>. Verifieer per situatie bij AIMA, Finanças, Segurança Social en een eigen fiscalist/advogado; regels veranderen.</p>
        </>
      )}
    </section>
  );
}
